<div class="profile-container">
  <div class="profile-content">
    <div class="personal-details">
      <div class="header-block">
        <div class="header-title">
          <app-breadcrumb></app-breadcrumb>
        </div>
        <div class="add-block">
   
          <div class="filter-icon">
            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 table-data">
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 60%;" >{{ 'object-template.templateName' | translate }}</th>
                <th style="width: 20%;">{{ 'object-template.counts' | translate }}</th>
                <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>

              </tr>
            </thead>
          </table>
          <div *ngIf="!isLoading">
            <div class="data-view" *ngFor="let list of templateCountsList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }  ;let i = index">
          
              <p style="width: 60%;">{{list.templateName}}</p>
              <p style="width: 20%;">{{list.counts || '--'}}</p>
                                  
            <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                <i  title="View" (click)="templateSelect(list)" class="bi bi-eye-fill"></i>
            </p>
            </div>
          </div>


          <div class="loader" *ngIf="isLoading">
            <div class="spinner"></div>
          </div>

          <div class="loader" *ngIf="!isLoading && templateCountsList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div>

          <div class="paginator" *ngIf="!isLoading && templateCountsList.length != 0">
            <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
              [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
            </p-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
